module.exports = __webpack_public_path__ + "static/media/eye-on.0a0b508d.svg";